// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3wErS","column":"style_column__1cIM5","row":"style_row__aE82j","wrapperAccordion":"style_wrapperAccordion__2kpeU"};